


























































































































import {
  computed,
  defineComponent,
  onMounted,
  reactive,
  Ref,
  ref,
  watch,
} from '@vue/composition-api';
import { useMutation, useQuery, useResult } from '@vue/apollo-composable';
import { useRouter, useFormat } from '@ideavivat/vivat-2';

import CommonChip from '@/components/CommonChip.vue';
import CommonValueItem from '@/components/CommonValueItem.vue';

import getDelivery from '@/gql/delivery/getDelivery.gql';
import getCompany from '@/gql/company/getCompany.gql';
import updateDeliveryStatus from '@/gql/delivery/updateDeliveryStatus.gql';

import useDelivery, { DEFAULT_DELIVERY } from '@/useDelivery';
import useDeliveryAreaCode from '@/useDeliveryAreaCode';
import { AUTH_TOKEN } from '@/useApollo';

const UpdateTracking = defineComponent({
  components: {
    CommonChip,
    CommonValueItem,
  },
  setup() {
    const confirmPopup = ref(false);
    const { distanceTypeToChipClass } = useDeliveryAreaCode();

    const { router, route } = useRouter();
    const delivery: Ref<any> = ref({});
    const pendingEditRemarks: Ref<boolean> = ref(false);
    const pendingEditfailureReason: Ref<boolean> = ref(false);
    const form = reactive({
      remarks: '',
      failureReason: '',
    });
    const { result: getDeliveryResult, loading } = useQuery(getDelivery, computed(() => ({
      trackingCode: route.value.params.id,
    })), () => ({
      fetchPolicy: 'network-only',
    }));
    const deliveryResult = computed(() => getDeliveryResult.value?.delivery || DEFAULT_DELIVERY);
    watch(() => deliveryResult.value, (newVal, oldVal) => {
      if (!loading.value && newVal !== oldVal) {
        delivery.value = {
          ...deliveryResult.value,
          deliveryLogs: [
            ...deliveryResult.value.deliveryLogs,
            { id: -1, status: 'PURCHASE', createdAt: deliveryResult.value.orderDate },
          ],
        };

        form.remarks = deliveryResult.value.remarks || '';
        form.failureReason = deliveryResult.value.failureReason || '';
      }
    });
    const computedAddress = computed(() => {
      if (deliveryResult.value.id) return `${deliveryResult.value.address?.address} ${deliveryResult.value.address.province?.nameInThai} ${deliveryResult.value.address.district?.nameInThai ? deliveryResult.value.address.district.nameInThai : ''} ${deliveryResult.value.address.subdistrict?.nameInThai ? deliveryResult.value.address.subdistrict.nameInThai : ''}`;
      return '';
    });
    const {
      shipmentStatusClassMap,
      translate: shipmentStatusTranslate,
      english: statusListEng,
    } = useDelivery();
    const reversedDeliveryLog = computed(() => {
      if (!loading.value) {
        if (delivery.value?.deliveryLogs?.length <= 0) return undefined;
        return delivery.value?.deliveryLogs?.sort((deliveryLogs: any, dL: any) => dL.id - deliveryLogs.id);
      }
      return undefined;
    });

    function toDate(val: any) {
      return useFormat.date(val).displayFullThaiDate();
    }

    const updateDeliveryItem = ref({
      id: -1,
      status: 'PENDING',
    });
    const updateDeliveryStatusMutation = useMutation(updateDeliveryStatus, () => ({
      refetchQueries: ['getDelivery', 'getDeliveries'],
    }));
    function updateDeliveryStatusAction() {
      if (updateDeliveryItem.value.status === 'HUB') {
        updateDeliveryStatusMutation.mutate({
          id: deliveryResult.value.id,
          input: {
            status: 'SUCCESS',
            remarks: form.remarks && form.remarks !== delivery.value.remarks ? form.remarks : undefined,
          },
          failureReason: form.failureReason && form.failureReason !== delivery.value.failureReason ? form.failureReason : undefined,
        });
      } else {
        updateDeliveryStatusMutation.mutate({
          id: deliveryResult.value.id,
          input: {
            status: updateDeliveryItem.value.status,
            remarks: form.remarks && form.remarks !== delivery.value.remarks ? form.remarks : undefined,
          },
          failureReason: form.failureReason && form.failureReason !== delivery.value.failureReason ? form.failureReason : undefined,
        });
      }
    }
    updateDeliveryStatusMutation.onDone(() => {
      delivery.value.status = updateDeliveryItem.value.status;
      confirmPopup.value = !confirmPopup.value;
      pendingEditRemarks.value = false;
      pendingEditfailureReason.value = false;
    });

    const { result: companyResult } = useQuery(getCompany);
    const company = useResult(companyResult, { logoUrl: '/logo_generic.svg', backgroundUrl: '/img/background/bg-generic.png' }, (data: any) => data.company);

    const computedDeliveryArea = computed(() => {
      if (delivery.value.area !== null) return delivery.value.area;
      return { code: 'NA', name: '', distanceType: '' };
    });

    async function checkAuthenticate() {
      if (!(localStorage.getItem(AUTH_TOKEN))) {
        router.push({
          name: 'Login',
          query: {
            redirectName: 'AppUpdateTrackingStatus',
            id: route.value.params.id,
          },
        });
      }
    }

    onMounted(async () => {
      await checkAuthenticate();
    });

    return {
      toDate,
      distanceTypeToChipClass,
      company,

      form,
      pendingEditRemarks,
      pendingEditfailureReason,

      updateDeliveryItem,
      confirmPopup,

      delivery,
      computedAddress,

      statusListEng,
      shipmentStatusClassMap,
      shipmentStatusTranslate,
      reversedDeliveryLog,

      updateDeliveryStatusAction,

      computedDeliveryArea,
    };
  },
});

export default UpdateTracking;
